import React from 'react';
import './Hero.css';
import logo from '../../assets/images/logo.png';

interface HeroProps {
  showScreenshot?: boolean;
}

const Hero: React.FC<HeroProps> = ({ showScreenshot = true }) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="logo-container">
            <img 
              src={logo} 
              alt="AInstein Logo" 
              className="app-logo"
              width="200"
              height="60"
            />
          </div>
          <h2>Learn everything with AInstein - your AI learning companion</h2>
          <p className="subtitle">
            AInstein helps your create quizzes, flashcards and lessons from PDFs, photos, audio, youtube videos and more. Master any subject and get valauble insights on your learning progress.
          </p>
          <div className="cta-buttons">
            <a href="https://apps.apple.com/us/app/ainstein-ai-lessons-quizzes/id6746379171" className="download-btn ios" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-apple"></i>
              <div>
                <span>Download on the</span>
                <span>App Store</span>
              </div>
            </a>
            <a 
              href="#" 
              className="download-btn android" 
              onClick={(e) => {
                e.preventDefault();
                alert('AInstein is coming soon to Android!');
              }}
            >
              <i className="fab fa-google-play"></i>
              <div>
                <span>GET IT ON</span>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>
        {showScreenshot && (
          <div className="phone-mockup">
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-screen">
                <div className="screenshot-placeholder">
                  <span>App Screenshot</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
